import { Image } from '@graphcommerce/image'
import { Box } from '@mui/material'
import { paymentLogos } from './payment-logos'

export function PaymentMethods() {
  return (
    <Box
      component='ul'
      sx={(theme) => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: { xs: 3, sm: 3.5, md: 4 },
        alignItems: 'center',
        px: 0,
        py: { xs: 1, sm: 0.6, md: 0.45, lg: 0.3 },
        my: 0,
      })}
    >
      {paymentLogos?.map((item) => {
        const paymentLogo = (
          <Image
            src={item.asset}
            height={item.asset.height}
            alt={item.alt}
            unoptimized
            sx={{
              width: () => {
                const widthBase = 21
                const scaleFactor = 0.525
                const naturalWidth = item?.asset?.width || 0
                const naturalHeight = item?.asset?.height || 0
                const imageRatio = naturalWidth / naturalHeight
                const width = imageRatio ** scaleFactor * widthBase
                return { xs: width * 0.8, sm: width * 0.8, md: width * 0.9, lg: width }
              },
              display: 'block',
            }}
          />
        )
        return (
          <Box key={item.asset.src} component='li' sx={{ display: 'inline-flex' }}>
            {paymentLogo}
          </Box>
        )
      })}
    </Box>
  )
}
